import {PayloadAction} from '@reduxjs/toolkit';
//types
import {
	IEventTodoList,
	IOrganizationEvent,
	IOrganizationEventReducer,
	IOrganizationSponsorCategoryResponse,
} from '../../utils/types';
import {userStorage, orgStorage} from '@/utils/services/storage.service';
//enums
import {STORAGE_KEY} from '@/utils/enums';

export const pendingOperation = (state: IOrganizationEventReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IOrganizationEventReducer) => {
	state.isLoading = false;
};

export const getEventSponsorCategoriesOperation = (
	state: IOrganizationEventReducer,
	{payload}: PayloadAction<IOrganizationSponsorCategoryResponse[]>
) => {
	state.sponsorCategories = payload;
	state.isLoading = false;
};

export const getEventsOperation = (
	state: IOrganizationEventReducer,
	{payload}: PayloadAction<IOrganizationEvent[]>
) => {
	state.events = payload;
	state.isLoading = false;
};

export const getEventOperation = (state: IOrganizationEventReducer, {payload}: PayloadAction<IOrganizationEvent>) => {
	state.currentEvent = payload;
	orgStorage.set(STORAGE_KEY.ORGANIZATION_EVENT_ID, payload.id);
	state.isLoading = false;
};

export const getEventTodoListOperation = (
	state: IOrganizationEventReducer,
	{payload}: PayloadAction<IEventTodoList[]>
) => {
	state.todoList = payload;
	state.isLoading = false;
};

export const clearEventDataOperation = (state: IOrganizationEventReducer, initialState: IOrganizationEventReducer) => {
	Object.assign(state, initialState);
};

export const updateEventOperation = (
	state: IOrganizationEventReducer,
	{payload}: PayloadAction<IOrganizationEvent>
) => {
	state.currentEvent = payload;
	state.isLoading = false;
};

export const getEventBySlugOperation = (
	state: IOrganizationEventReducer,
	{payload}: PayloadAction<IOrganizationEvent>
) => {
	state.currentEvent = payload;
	userStorage.set(STORAGE_KEY.ORGANIZATION_EVENT_ID, payload.id);
	state.isLoading = false;
};
